/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AddChatMessageTemplateInput = {
  body: string;
  label: string;
  selections: Array<string>;
};

export type UpdateChatMessageTemplateInput = {
  body: string;
  guid: string | number;
  label: string;
  selections: Array<string>;
};

export type ChatMessageTemplateOnUseChatMessageTemplateFragment = { guid: string, label: string, body: string, selections: Array<string> };

export type ViewerOnUseChatMessageTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerOnUseChatMessageTemplateQuery = { viewer: { chatMessageTemplates: Array<{ guid: string, label: string, body: string, selections: Array<string> }> } };

export type AddChatMessageTemplateMutationVariables = Exact<{
  input: Types.AddChatMessageTemplateInput;
}>;


export type AddChatMessageTemplateMutation = { addChatMessageTemplate: Array<{ guid: string, label: string, body: string, selections: Array<string> }> };

export type UpdateChatMessageTemplateMutationVariables = Exact<{
  input: Types.UpdateChatMessageTemplateInput;
}>;


export type UpdateChatMessageTemplateMutation = { updateChatMessageTemplate: { guid: string, label: string, body: string, selections: Array<string> } };

export type DeleteChatMessageTemplateMutationVariables = Exact<{
  guid: string | number;
}>;


export type DeleteChatMessageTemplateMutation = { deleteChatMessageTemplate: Array<{ guid: string, label: string, body: string, selections: Array<string> }> };

export const ChatMessageTemplateOnUseChatMessageTemplateFragmentDoc = gql`
    fragment ChatMessageTemplateOnUseChatMessageTemplate on ChatMessageTemplate {
  guid
  label
  body
  selections
}
    `;
export const ViewerOnUseChatMessageTemplateDocument = gql`
    query ViewerOnUseChatMessageTemplate {
  viewer {
    chatMessageTemplates {
      ...ChatMessageTemplateOnUseChatMessageTemplate
    }
  }
}
    ${ChatMessageTemplateOnUseChatMessageTemplateFragmentDoc}`;

/**
 * __useViewerOnUseChatMessageTemplateQuery__
 *
 * To run a query within a Vue component, call `useViewerOnUseChatMessageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerOnUseChatMessageTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewerOnUseChatMessageTemplateQuery();
 */
export function useViewerOnUseChatMessageTemplateQuery(options: VueApolloComposable.UseQueryOptions<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables>(ViewerOnUseChatMessageTemplateDocument, {}, options);
}
export function useViewerOnUseChatMessageTemplateLazyQuery(options: VueApolloComposable.UseQueryOptions<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables>(ViewerOnUseChatMessageTemplateDocument, {}, options);
}
export type ViewerOnUseChatMessageTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewerOnUseChatMessageTemplateQuery, ViewerOnUseChatMessageTemplateQueryVariables>;
export const AddChatMessageTemplateDocument = gql`
    mutation addChatMessageTemplate($input: AddChatMessageTemplateInput!) {
  addChatMessageTemplate(input: $input) {
    ...ChatMessageTemplateOnUseChatMessageTemplate
  }
}
    ${ChatMessageTemplateOnUseChatMessageTemplateFragmentDoc}`;

/**
 * __useAddChatMessageTemplateMutation__
 *
 * To run a mutation, you first call `useAddChatMessageTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddChatMessageTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddChatMessageTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddChatMessageTemplateMutation(options: VueApolloComposable.UseMutationOptions<AddChatMessageTemplateMutation, AddChatMessageTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddChatMessageTemplateMutation, AddChatMessageTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddChatMessageTemplateMutation, AddChatMessageTemplateMutationVariables>(AddChatMessageTemplateDocument, options);
}
export type AddChatMessageTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddChatMessageTemplateMutation, AddChatMessageTemplateMutationVariables>;
export const UpdateChatMessageTemplateDocument = gql`
    mutation updateChatMessageTemplate($input: UpdateChatMessageTemplateInput!) {
  updateChatMessageTemplate(input: $input) {
    ...ChatMessageTemplateOnUseChatMessageTemplate
  }
}
    ${ChatMessageTemplateOnUseChatMessageTemplateFragmentDoc}`;

/**
 * __useUpdateChatMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateChatMessageTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMessageTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateChatMessageTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChatMessageTemplateMutation(options: VueApolloComposable.UseMutationOptions<UpdateChatMessageTemplateMutation, UpdateChatMessageTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateChatMessageTemplateMutation, UpdateChatMessageTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateChatMessageTemplateMutation, UpdateChatMessageTemplateMutationVariables>(UpdateChatMessageTemplateDocument, options);
}
export type UpdateChatMessageTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateChatMessageTemplateMutation, UpdateChatMessageTemplateMutationVariables>;
export const DeleteChatMessageTemplateDocument = gql`
    mutation deleteChatMessageTemplate($guid: ID!) {
  deleteChatMessageTemplate(guid: $guid) {
    ...ChatMessageTemplateOnUseChatMessageTemplate
  }
}
    ${ChatMessageTemplateOnUseChatMessageTemplateFragmentDoc}`;

/**
 * __useDeleteChatMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteChatMessageTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMessageTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteChatMessageTemplateMutation({
 *   variables: {
 *     guid: // value for 'guid'
 *   },
 * });
 */
export function useDeleteChatMessageTemplateMutation(options: VueApolloComposable.UseMutationOptions<DeleteChatMessageTemplateMutation, DeleteChatMessageTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteChatMessageTemplateMutation, DeleteChatMessageTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteChatMessageTemplateMutation, DeleteChatMessageTemplateMutationVariables>(DeleteChatMessageTemplateDocument, options);
}
export type DeleteChatMessageTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteChatMessageTemplateMutation, DeleteChatMessageTemplateMutationVariables>;